import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import { Ref, promise, findVendor, cache, equal, copy} from '../../global'
import React, {Suspense, memo, useState, useEffect, useContext} from 'react'
// import { ParkContext } from '../../context'
import action from '../../action/'
import Loading from './view/loading'
import Header from './header'
import {Toast} from '../master/toast'
import Body from './body'
import Footer from './footer'
import OctagonStar from '../../graphic/OctagonStar'
import octagon from '../../graphic/octagon.svg'
import {dispatch, tcp, tcp2, go} from '../../io'
import { useSelector, useDispatch } from 'react-redux'
export const ID = 'row'
Ref[ID] = {}
const _Row_ = Ref[ID]
let _row_ = 0
const _Row = prop => {
  const { param, paramCart, uid, verb: mverb, login, wakeup, cookie, lang, vendor, u, owner, master, e, route} = prop.master
if (Ref.socket.connected && prop.online?.uid && prop.online?.deleteStage && prop.online?.deleteStage==prop.online?.uid) {
  debugger
  return null
}
  const { db, v, park } = prop
  // if (!(park[v]?.[db])) return <Suspense fallback={<Loading/>}/>
  // if (!(park[v]?.[db])) {debugger;return "waiting"}
  const {sell, offset, print, storeConfig} = prop.table
  const selection = JSON.parse(param.selected || '[]')
  const pk = isNaN(prop.table.pk) ? prop.table.pk : Number(prop.table.pk)
  // const io = initIO(ID, db, v, pk)
// if (isNaN(prop.table.pk)) debugger
  const _verb = prop.ID=='state' &&  _.Q_.includes(v) ? ((pk<0||isNaN(pk)) && v!='purchase' ? 'insert' : 'default') : mverb
  const fid = v=='item' ? 'items' : (v=='media' ? 'medias' : (v=='review' ? 'reviews' : null))
  // const [ _toggle, setToggle ] = useState()
  // const toggle = () => {
  //   setToggle(!_toggle)
  //   if (prop.toggle) prop.toggle()
  // }
  // const [ row, _setRow ] = useState({
  //   _id_: _row_++,
  //   key: `${ db } ${ v } ${ pk } ${ _verb }`,
  //   verb: _verb,
  //   // collapse: !_.JSON_FLIP_[v] && typeof io.collapse!='undefined' ? io.collapse : (_.Q_.includes(v) ? ((pk<0||isNaN(pk)) ? prop.ID=='state' : true) : false),
  //   collapse: _.Q_.includes(v) ? ((pk < 0 || isNaN(pk)) ? prop.ID=='state' : true) : false,
  //   init: false,
  //   preview: false,
  //   title: '',
  //   select: selection.includes(pk),
  //   fields: {},
  // })
  // const { fields, select, verb: rverb, collapse: _collapse, init, preview, stale } = row
  // let verb = rverb, collapse = _collapse
  // const setRow = arg => {
  //   if (!arg.preview) delete(arg.preview)
  //   _setRow(_s => {
  //     const s = {..._s, ...arg}
  //     // Ref[ID][row._id_].row = s
  //     return s
  //   })
  // }
  const cart = Object.keys({ ...prop.cart })
  useEffect(() => {
    if (cart.length == 0) return
    const { localPurchase, remotePurchase, callback } = prop.cart
if (!remotePurchase) debugger
    if (!remotePurchase) return
    debugger
    return () => action.cart()
  }, [cart.length])
  // const _stale = () => verb!='default' && Object.keys(Fields[db][v][pk][verb]).reduce((acc, id) => {
  //   acc |= Fields[db][v][pk][verb][id][''].state.stale
  //   if (acc) console.log({acc, verb, pk, id, stale: Fields[db][v][pk][verb][id][''].state.stale})
  //   return acc
  // }, false)
  const {vid, display, cfgId: _cfgId, cfgRow: _cfgRow, vendorRow} = findVendor(prop)
  const cfgId = v=='config' ? pk : _cfgId
  const cfgRow = v=='config' ? park[v][db].default[pk] : _cfgRow
  const username = vendorRow?.username
  const shard = vendorRow && username!='master' ? vendorRow.home : (vendor.home || cookie.p)
  const printer = park[v][_.Q_.includes(v) ? 'default' : _verb]
  const store = park[v][db]
  if (!store) debugger
  const rows = { ...store.default }
  const r = rows[pk]
  const className = ['collapse']
  // const id = `${ID}${db}${v}${pk}${verb}`
  // if (!collapse) className.push('expand')
  // if (!r || r=='find' || (window.opener && param.v=='item' && (pk<0 || isNaN(pk)) && paramCart)) {
  //   console.log({[ID]: `NO`, r})
  //   return null
  // }
  const [ _toggle, setToggle ] = useState()
  const toggle = () => {
    setToggle(!_toggle)
    if (prop.toggle) prop.toggle()
  }
  const [ row, _setRow ] = useState({
    _id_: _row_++,
    key: `${ db } ${ v } ${ _verb } ${ pk }`,
    verb: _verb,
    // collapse: !_.JSON_FLIP_[v] && typeof io.collapse!='undefined' ? io.collapse : (_.Q_.includes(v) ? ((pk<0||isNaN(pk)) ? prop.ID=='state' : true) : false),
    collapse: _.Q_.includes(v) ? ((pk < 0 || isNaN(pk)) ? prop.ID=='state' : true) : false,
    init: false,
    preview: false,
    title: '',
    select: selection.includes(pk),
    fields: {},
  })
  const { fields, select, verb: rverb, collapse: _collapse, init, preview, stale } = row
  const setRow = nextRow => _setRow(prevRow => typeof nextRow == 'function' ? nextRow(prevRow) : ({ ...prevRow, ...nextRow }))
    // return typeof nextState == 'function' ? nextState(prevState) : { ...prevState, ...nextState }
  // })
  let verb = rverb, collapse = _collapse
  if (!collapse) className.push('expand')
  useEffect(() => {
    _Row_[row.key] = { toggle, row, setRow, rowUpdate, rowClick, cfgRow, vendorRow }
    return () => delete(_Row_[row.key])
  }, [])
  const onSelect = e => {
    if (e) debugger
    const _select = param.select > 1 ? !select : 1
    setRow({select: _select})
    p.setSelect(pk, _select)
  }
  const rowClick = (_db, _v, _pk, _collapse=!collapse, _init=init) => {
    const stagePk = isNaN(_db)
    let _shard = shard//, tcp2 = false
    if (window.opener && pk>0 && paramCart) return onSelect()
    if (!_.Q_.includes(v)) return
    console.log({[ID]: 'rowClick', lang, db, v, pk, row})
    const buffer = {}
    const find = (db, view, pk, id, v='media') => {
      JSON.parse(r[id]).reduce((acc, fpk, i) => {
        if (!(i<_.LIMIT)) return
        const _r = park[v]?.[db]?.default[fpk]// || cache(`${lang}${db}${v}${fpk}`)
        if (!_r || r!='find') {
          if (!buffer[v]) buffer[v] = {}
          if (!buffer[v][db]) buffer[v][db] = {}
          if (!buffer[v][db].default) buffer[v][db].default = {}
          buffer[v][db].default[fpk] = 'find'
        }
      }, [])
    }
    const { vid, display, cfgId, cfgRow, vendorRow } = findVendor(prop)
    // const from = rows[pk][_.FROM]
    const from = rows[pk].vendor
    // if (!vendorRow || (from && !(park.user && park.user.default[from]))) {
    if (!vendorRow || (from && !(park?.login?.user?.default?.[from]))) {
      buffer.login = {user: {default: {[from || vid]: 'find'}}}
      if (vendorRow) {
        dispatch({buffer: {[cookie.p]: {login: {user: {default: {[vid]: vendorRow}}}}}})
      } else {
        _collapse = true
        _init = false
        tcp2({
          request: {type: 'table', find: [from || vid]},
          credential: true,
          url: `https://${cookie.p}.${_.DOMAIN}/fec/table${__DEV__ ? '.dev' : ''}.php?api=id`,
          parking: false,
          callback: response => {
            const id = typeof response == 'object' && Object.keys(response).length && Object.keys(response)[0]
            if (id) {
              const buff = {[cookie.p]: {login: {user: {default: {[id]: response[id]}}}}}
              dispatch({buffer: buff})
            }
          }
        })
      }
    } else if (pk > 0 || Ref.socket.connected) {
      if (!_init) {
        if (!cfgRow) buffer.config = {[vid]: {count: _.PUB, default: []}}
        if (_.Q_.includes(v) && r.json) {
if (v=='notice') debugger // need more work
if (v=='follow') debugger // need more work
          const js = JSON.parse(r.json)
          let j = js
          switch (v) {
            case 'notice':
            case 'follow':
            j = Object.keys(js)
          }
          j.forEach(json => {
            const [kpk, stock, buy, v='item', kmemo=''] = json
            const {follow} = json
if (follow) debugger
if (r.type=='follow') debugger
            const _r = park[v]?.[vid]?.default?.[kpk]
            const printer = park[v]?.default
            if (!_r) {
              if (!buffer[v]) buffer[v]={}
              if (!printer) buffer[v].default = 'find'
              if (!buffer[v][vid]) buffer[v][vid]={}
              if (!buffer[v][vid].default) buffer[v][vid].default = {}
              buffer[v][vid].default[kpk] = 'find'
            }
          })
        }
        if (r.medias) find(vid, v, pk, 'medias', 'media')
        _init=true
      }
    }
    setRow({collapse: _collapse, init: _init})
    if (Object.keys(buffer).length) {
      if (!buffer.login) tcp({buffer: {[_shard]: buffer}, lang, u, route, _id_: row._id_, ID})
      // prop.setWakeup({wakeup: buffer, meta: {db, v, pk}})
    }
    // toggle()
  } // rowClick
  // const [field, _setField] = useState({})
  // const setFields = (id, callbacks) => {
  //   const fs = { ...fields }
  //   fs[id] = callbacks
  //   setRow({fields: fs})
  // }
  // const _stale = () => verb!='default' && Object.keys(field).reduce((acc, id) => {
  //   acc |= Ref[ID][].state.stale
  //   Object.keys(prop.row.field).reduce((acc, fid) => {
  //     prop.row.field[fid]
  //   }, false)
  //   if (acc) console.log({acc, verb, pk, id, stale: Fields[db][v][pk][verb][id][''].state.stale})
  //   return acc
  // }, false)
  const onStale = (id, _stale) => setRow({ stale: stale | _stale})
  const onFieldMount = (id, callbacks) => setRow(prevState => ({
    ...prevState,
    fields: {
      ...prevState.fields,
      [id]: callbacks,
    }
  }))
  const onFieldUnmount = id => {
    if (!fields[id]) return
    const fs = { ...fields }
    delete(fs[id])
    setRow({fields: fs})
  }
  const rowUpdate = callback => {
    Object.keys(fields).forEach(id => {
      if (fields[id][callback]) {
        fields[id][callback]()
      } else debugger
    })
  }
  const onFieldChange = (id, fState) => setRow(prevState => {
    const s = {
      ...prevState,
      stale: stale | fState.stale,
      preview: fState.preview,
    }
    // console.log({id, fState, s}, _Row_[fState._id_])
    if (v == 'media') {
      if (id == 'title') {
        s.title = fState.value
        s.stale = fState.stale
      }
      if (id == 'selectmedia' && pk > 0) {
        s.preview = fState.json[0]
        s.stale = fState.stale
        s.title = fState.json[0].title
        s.type = fState.json[0].type
        // Ref[ID][row._id_]
        Object.keys(prop.row.fields).reduce((acc, fid) => {
          switch (fid) {
            case 'title':
            case 'type':
if (!prop.row.fields[fid].setState) debugger
            // prop.row.fields[fid].setState({ [fid]: s.title })
            prop.row.fields[fid].setState({ [fid]: s[fid] })
          }
        }, [])
        // Fields[db][v][pk][verb].title[''].setState({value: s.title, stale: true})
        // Fields[db][v][pk][verb].type[''].setState({value: s.type})
      }
    }
    return s
  })
  const _onFieldChange = (id, fState) => {
    const s = {
      stale: stale | fState.stale,
      preview: fState.preview,
    }
    // console.log({id, fState, s}, _Row_[fState._id_])
    if (v == 'media') {
      if (id == 'title') {
        s.title = fState.value
        s.stale = fState.stale
      }
      if (id == 'selectmedia' && pk > 0) {
        s.preview = fState.json[0]
        s.stale = fState.stale
        s.title = fState.json[0].title
        s.type = fState.json[0].type
        // Ref[ID][row._id_]
        Object.keys(prop.row.fields).reduce((acc, fid) => {
          switch (fid) {
            case 'title':
            case 'type':
if (!prop.row.fields[fid].setState) debugger
            prop.row.fields[fid].setState({ [fid]: s.title })
          }
        }, [])
        // Fields[db][v][pk][verb].title[''].setState({value: s.title, stale: true})
        // Fields[db][v][pk][verb].type[''].setState({value: s.type})
      }
    }
    setRow(s)
  }
  // io.row=row
  // io.toggle=toggle
  // io.setRow=setRow
  // io.rowUpdate=rowUpdate
  // io.rowClick=rowClick
  // io.cfgRow=cfgRow
  // io.vendorRow=vendorRow
  // io.onFieldChange=onFieldChange
  // Ref[ID][row._id_] = {toggle, setRow, rowUpdate, rowClick, cfgRow, vendorRow}
  const neverStale = v=='purchase' && pk<0
  // const neverStale = isNaN(prop.online?.u?.id)
  const p = {neverStale, ...prop, row: {...row, stale, cfgRow, vendorRow}, setRow, rowUpdate, rowClick, onFieldUnmount, onStale, onFieldMount, onFieldChange, toggle}
  let desc=true, d, date, /*key,*/ itemName, i, buffer, buy, stock, title='favicon', file=prop.master.media.src
  // if (pk<0 && _.Q_.includes(v)) desc = `${master[_.NEW_][_.I]} ${master[v][_.I]}`
  if ((pk<0 || isNaN(pk)) && _.Q_.includes(v)) desc = `${master.new.i} ${master[v].i}`
  else if (!_.MASTER_.includes(v)) desc = row.title || r.title// || display
  // else if (!_.MASTER_.includes(v)) desc = row.title || r[_.TITLE] || display
  if (!desc && v=='purchase') desc=display
  // if (pk==64)debugger
  if (preview) { // for header prop.before
    title = preview.title
    file = preview.src
  }
  // key = `${u}${db}${v}${pk}${verb}`
  // const k = `${db}${u}${v}${pk}`
  if (v=='error') {
    const search = window.location.search.split('=')
    if (search.length) {
      // const t = window.location.search.split('=')[1]
      const t = search[1]
      desc = <a onClick={e=>{e.preventDefault(); prop.history.push(`/${lang}/master/${t}`)}}>{t}</a>
    }
  }
  itemName = sell && r.title
  if (u=='media' && pk>0) file = preview.src || `https://${shard}.${_.DOMAIN}/usr/${db}/media/${r.uri}.${r.type}`
  if (!preview && pk>0 && r.medias) {
    i = JSON.parse(r.medias)
    const fpk = i.length ? i[0] : 0
    if (i.length && park.media[db].default[fpk]) {
// if (i.length && park[_.FILE][db].default[fpk] && !Array.isArray(park[_.FILE][db].default[fpk])) debugger
      const f = park.media[db].default[fpk]
      file = `https://${shard}.${_.DOMAIN}/usr/${db}/media/${f.uri}.${f.type}`
      title = f.title
// if (!f.uri)debugger
    }
// else debugger
  }
  const propHeader = {...p, r, content:[], before: [], vid, buy, file, desc, print: true, onClick: prop.onClick || rowClick}
  const footer = (_.CART_.includes(v) && collapse && !cfgRow) ? '' : <Footer {...p} key='footer'/>
  // const image = <img key={_.PREVIEW} src={file} alt={title} title={title} className={`${_.HEADER} ${u} ${v} ${verb} ${v=='config' ? 'max' : (collapse ? 'min' : 'max')}`}/>
  const getImage = class_ => {
    const pImage = {src: file, alt: title, className: ['header', u, v, verb]}
    if (class_) pImage.className.push(class_)
    pImage.className = pImage.className.join(' ')
    return <img {...pImage} key='preview'/>
  }
  const keySelect = `${ row.key } select`
  const pSelect = {
    type: param.select>1 ? 'checkbox' : 'radio',
    id: keySelect,
    // key: `${key}input`,
    name: 'select',
    checked: select,
    onChange: onSelect,
  }
  const selectInput = (
    <label htmlFor={keySelect} key={`${keySelect}label`}>
      <input {...pSelect}/>
      {master.select.i} {/*master[v][_.I]*/}
    </label>
  )
  if (r.medias/* || r.items || r.reviews*/) {
// if (prop.body?.id=='items') debugger
    const minImage = getImage()
    const maxImage = getImage('max')
    if (collapse) {
      if ((!_.FILE_OPTIONAL_.includes(v) || r.medias!='[]') && pk>0) {
        if (v=='item' || v=='config' || v=='review') propHeader.before.push(maxImage)
        else propHeader.content.push(minImage)
      }
    } else if ((!_.FILE_OPTIONAL_.includes(v) || r.medias!='[]') && pk>0) {
      propHeader.before.push(maxImage)
    }
  } else if ((v=='media' || v=='item' || v=='review') && pk>0) {
    if (window.opener && paramCart) {
      propHeader.content.push(getImage())
      propHeader.content.push(<div key='title'>{r.title}</div>)
      propHeader.content.push(selectInput)
    } else {
if (!r.album)debugger
if (!master[r.album])debugger
      if (collapse) propHeader.content.push(getImage(), master[r.album].i)
      else propHeader.before.push(getImage('max'))
    }
  }
  if (sell) {
    if (pk>0 && verb=='default') {
      propHeader.before.push(
        <div key='rate'>{r.rate} star</div>,
        <div key='review'>{`${JSON.parse(r.reviews).length} ${master.review.i}`}</div>,
      )
      if (prop.ID=='state') {
        if (window.opener && paramCart) {
          propHeader.content.push(<div key='title' style={{textAlign: 'center', maxWidth: '50%'}}>{r.title}</div>)
          propHeader.content.push(selectInput)
        }
        else {
          propHeader.content.push(
            <span key='currency'>{`${cfgRow ? cfgRow.currency : ''} ${r.price}`}</span>,
            footer,
          )
        }
      } else {
        propHeader.before.push(
          <div key='currency'>{`${cfgRow ? cfgRow.currency : ''} ${r.price}`}</div>,
          footer,
        )
      }
      // propHeader.content.push(
      //   // <span key={_.RATE}>{r[_.RATE]} star</span>,
      //   // <span key={_.REVIEW}>{`${JSON.parse(r[REVIEWS]).length} ${master[_.REVIEW][_.I]}`}</span>,
      //   // <span key={_.CURRENCY}>{`${cfgRow ? cfgRow[_.CURRENCY] : ''} ${r[_.PRICE]}`}</span>,
      //   footer,
      // )
    }
  } else if (v=='follows') {
  } else if (v=='hours') {
    propHeader.content.push(
      <span key='open'>{r.open}</span>,
      <span key=':'>{r.close ? '---' : ''}</span>,
      <span key='close'>{r.close}</span>,
    )
  } else if (!storeConfig && collapse && pk>0) {
  // } else if (!storeConfig && pk>0) {
    // if (collapse) {
    switch (v) {
      case 'menu': d = new Date(r.expire*1000); break
      default: d = new Date(r.modified*1000)
    }
    date = d instanceof Date && !isNaN(d) ? d.toDateString() : master.new.i
    propHeader.before.push(<div key='time'>{`${v=='menu' ? 'Until ':''}${date}`}</div>)
    if (r.items) propHeader.content.push(<span key='items'>{`${JSON.parse(r.items).length} ${master.item.i}`}</span>)
  // } else {
  //     if (r.items) propHeader.content.push(<span key='items'>{`${JSON.parse(r.items).length} ${master.item.i}`}</span>)
  //   }
  }
  if ((pk<0 || isNaN(pk)) && _.Q_.includes(v)) propHeader.before.push(
    <div key='logo'>
      <OctagonStar
        style={{fill:db<0 ? vw.COLOR_RED : vw.COLOR_THEME}}
        className={`logo ${collapse ? 'hide' : 'show'}`}
      />
    </div>
  )
  // if (pk<0 && u=='media') debugger
  // if (pk<0 && r.type==_.FOLLOW) debugger
  // if ((_.CART_.includes(v) || (v=='notice' && pk<0)) && r.json!='[]') {
  if ((_.CART_.includes(v) || (v=='notice' && (pk<0||isNaN(pk))))) {
  // if ((_.CART_.includes(v) || (v=='notice' && pk<0 && r.type==_.PURCHASE)) && r.json!='[]') {
    // propHeader.content.push(
    if (!r.json) debugger
    // if (!(r.type && r.type==_.FOLLOW)) propHeader.content.push(
    // if (!(r.type && r.type==_.FOLLOW)  && r.json!='[]') {
    //   if (prop.master.cartCount[vid]) debugger
    // }
    if (!(r.type && r.type=='follow')  && r.json!='[]') propHeader.content.push(
      // <span key={_.COUNT}>{JSON.parse(r.json).length} {master[_.ITEM][_.I]}</span>,
      <span key='count'>{JSON.parse(r.json).reduce((acc, [pk, stock]) => (acc+stock), 0)} {master.item.i}</span>,
      // <span key={_.COUNT}>{prop.master.cartCount[vid]} {master[_.ITEM][_.I]}</span>,
      // [vid]: JSON.parse(row.json).reduce((acc, [pk, stock]) => (acc+stock), 0)
    )
    // if (_.CART_.includes(v)) {
    if (collapse) propHeader.content.unshift(<span key='cart'>{master.cart.i}</span>)
    else if ((v=='purchase' || v=='notice') && !Ref.socket.connected) propHeader.content.unshift(footer)
    // }
  }
  if (e) {
    let t = window.location.pathname.split('/');
    t.shift() // always empty
    let username = _.MASTER_.includes(e) ? 'master' : cookie.username || t[1]
    // let link = _.PART_.includes(e) ? `https://${_.DOMAIN}/${lang}/${username}/${e}` : ''
    let link = _.PART_.includes(e) ? `https://${_.DOMAIN}/${username}/${e}?lang=${lang}` : ''
    content.unshift(<div key={`${u}e`}><b>Error {e}</b> {link}</div>)
  }
  // console.log({[ID]: prop.ID, select, db, v, pk, verb, wakeup})
  // const verbs = v=='login' || owner && pk>0 && u==v && !_.CART_.includes(v) && !prop.meta && v!='review'
  const verbs = v=='login' || owner && pk>0 && u==v && !_.CART_.includes(v) && v!='review'
  const deep = prop.deep ? 4-prop.deep : 4
  let color, thick=1, fontSize
  switch (prop.deep || 0) {
    case 0:  thick=2.5; color='#887'; break
    case 1:  thick=2.1; color='#996'; break
    case 2:  thick=1.7; color='#aa5'; break
    case 3:  thick=1.3; color='#bb4'; break
    case 4:  thick=0.9; color='#cc2'; break
    default: thick=0.5; color='#dd1'; break
  }
  const selected = window.opener && paramCart && select
  const style= _.MASTER_.includes(u) || storeConfig || (pk<0||isNaN(pk)) ? {} : {
    border: `${thick}px ${selected ? 'dashed' : 'solid'} ${selected ? vw.THEME : color}`, /*fontSize: 'smaller'*/
    padding: window.opener && paramCart ? '0 10px' : '24px',
    borderRadius: selected ? '24px' : '7px',
    margin: '12px auto',
  }
// if (prop.controller) className.push('expand')
  // useEffect(() => {
  //   _Row_[row.key] = { toggle, row, setRow, rowUpdate, rowClick, cfgRow, vendorRow }
  //   return () => delete(_Row_[row.key])
  // }, [])
  return (
    <Suspense fallback={<Loading/>}>
      <article
        _id_ = { row._id_ }
        style = { style }
        className = { `${ ID } ${ row.key } ${ storeConfig ? '' : (_.Q_.includes(v) && pk>0 ? 'border' : '') }` }
      >
        <Header { ...propHeader }/>
        <div
  /*        id = { row.key } */
          className = { `${ className.join(' ') } ${ row.key }` }
        >
          {
            verbs && <Verb {...p}/>
          }
          <Body { ...p }/>
        </div>
      </article>
    </Suspense>
  )
  // <div id = { row.key } className = { `${className.join(' ')} ${row.key}` }>
}
_Row.ID = ID
export const Row = _Row
// export default Row
export default React.memo(Row)
// export default React.memo(Row, (pp, np) => {
//   if (Object.keys({ ...pp.cart }).length) debugger
//   if (Object.keys({ ...np.cart }).length) debugger
//   return true
// })
const Verb = prop => {
  const { route, u, login, master, lang, cookie } = prop.master
  const { pk } = prop.table
  const { v, db, park } = prop
  // const select = IO.select
  let { stale } = prop.row
  if (!master) return null
  const p = {
    type: 'radio',
    name: `pk${pk}`,
    onChange: e => {
      const verb = e.target.dataset.verb
      if (v=='login') {
        const uri = _.LOGIN_FLIP_[verb] || _.LOGOUT_FLIP_[verb]
        // go(prop.history.replace, [lang, _.MASTER, uri])
        // go(prop.history.replace, [lang, uris[1], uri])
        go(prop.history.replace, [route[0], uri])
        // go(prop.history.replace, ['master', uri])
      } else prop.setRow({verb})
    },
  }
  var verbs = _.Q_.includes(v) ? (v=='follows' ? ['delete'] : _.SQL_) : (v=='login' ? (login ? Object.values(_.LOGIN_) : Object.values(_.LOGOUT_)) : 'default')
  if (v=='follow' || v=='media') verbs = ['delete', 'update', 'default']
  const content = verbs.reduce((acc, verb) => {
    const checked = verb==prop.row.verb
    let I = master[verb]
    switch (verb) {
      case 'default': if (v=='login') I = master.login; break
      case 'update': I = v=='login' ? master.profile : (v=='notice' ? master.reply : master.edit); break
      case 'insert': I = v=='login' ? master.register : master.clone
      if (v=='notice') I=null
      break
      case 'delete': I = v=='login' ? master.logout : master.remove
      break
    }
    const ip = {
      ...p,
      id: `${p.name}${verb}`,
      'data-verb': verb,
      checked,
      onClick: e => e.stopPropagation()
    }
    const lp = {
      htmlFor: ip.id,
      className: checked ? 'borderbottom' : '',
      onClick: e => e.stopPropagation()
    }
    if (I) acc.push(
      <span key={`${ verb }`}>
        <input { ...ip }/>
        <label { ...lp }> { I.i } </label>
      </span>
    )
    return acc
  }, [])
  return (
    <div
      className = 'flex'
      style = { { justifyContent: 'center' } }
    >
      {content}
    </div>)
}
// const data = {}
// export default React.memo(Row, (pp, np) => {
//   // const {db: pdb, v: pv} = pp
//   const { db: ndb, v: nv } = np
//   // const {u, park} = pp.master
//   const { u } = np.master
//   // const {pk: ppk} = pp.table
//   const {pk: npk} = np.table
//   // if (ppk<0 || isNaN(ppk)) return false
//   if (npk<0 || isNaN(npk)) return false
//   // const ppark = pp.master.park
//   // const npark = np.master.park
//   const ppark = pp.park
//   const npark = np.park
//   const park = npark
//   if (!ppark[nv]) {debugger;return false}
//   // const pdata = Object.keys(ppark[pv][pdb]).length
//   const ndata = npark[nv][ndb]
//   if (np.row?.verb=='update') debugger
//   if (!(pp.master.wakeup[nv]?.[ndb])) return true
//   // const wakeup = copy(np.master.wakeup[v][db][pk] || {})
//   const wakeup = np.master.wakeup[nv][ndb][npk] || {}
//   // const { callback, ...wakeup } = np.master.wakeup[nv][ndb][npk] || {}
// // if (Object.keys(wakeup).length>0) debugger
//   // const data_={}, value=[]
//   const value = []
//   if (Object.keys(wakeup).length==0) return ndata
//   // if (Object.keys(wakeup).length) {
//   // const Field = Fields[pdb]?.[pv]?.[ppk]?.[np.row ? np.row.verb : np.master.verb] || {}
//   // if (np.ID!='state' && u==v) {
//   //   console.log(`Row.memo ${np.ID}`, {db, v, pk})
//   //   return false
//   // }
//   let update=false, last//, Field//, offset
//   // const callback = wakeup.callback
//   Object.keys(wakeup).reduce((vs, v) => {
//     // if (v == 'callback') return vs
//      // const id = v==_.FILE ? FILES : (v==_.ITEM ? ITEMS : (v==_.REVIEW ? REVIEWS : null))
//     // const id = v=='media' ? 'medias' : null
//     const id = _.JSON_FLIP_[v]
// // offset = wakeup[v][_.OFFSET] || 0
//     Object.keys(wakeup[v]).reduce((dbs, db) => {
// if (db=='offset') {debugger;return dbs}
//       if (_.VERB_.includes(db)) { // tested
//         if (npark[v]?.[db]) { // tested
//           delete(wakeup[v][db])
//           update=true
//         }
//         return dbs
//       }
//       Object.keys(wakeup[v][db]).reduce((ks, k) => {//tested
//         switch (k) {
//           case 'print':
//           case 'offset':debugger
//           delete(wakeup[v][db][k])
//           update=true
//           return ks
//           case 'default':
//           if (Object.keys(wakeup[v][db].default).length==0) {
//             if (npark[v]?.[db]?.[`0${_.PUB}`]) { //tested ... offset 0 public is tested as only config row is searched
//               delete(wakeup[v][db].default)
//               update=true
//             }
//           } else {
//             Object.keys(wakeup[v][db].default).forEach((pk, i) => {
//               if (npark[v]?.[db]?.default?.[pk]) { //tested
//                 delete(wakeup[v][db].default[pk])
//                 value.push(Number(pk))
//                 update=true
//                 // Field = Fields[db][np.v][np.table.pk].default[id]
//                 // if (!data[db]) data[db]={}
//                 // if (!data[db][np.v]) data[db][np.v]={}
//                 // if (!data[db][np.v][np.table.pk]) data[db][np.v][np.table.pk]={}
//                 // if (id && Field[id]?.['']?.callback) {
//                   // Field[id][''].once=false
//                   // data[db][np.v][np.table.pk][id]=Fields[db][np.v][np.table.pk].default[id]
//                   // data[db][np.v][np.table.pk][id].once = false
//                 // }
//               }
//             })
//             if (Object.keys(wakeup[v][db].default).length==0) {// tested
//               update=true
//               delete(wakeup[v][db].default)
//             }
//             // if (data[db] && data[db][np.v] && data[db][np.v][np.table.pk] && data[db][np.v][np.table.pk][id] && !data[db][np.v][np.table.pk][id].once) {
//             // Field = Fields[db][np.v][np.table.pk].default[id]
// //             if (Field[id] && !Field[id][''].once) {
// //               // data[db][np.v][np.table.pk][id].once = true
// //               Field[id][''].once = true
// //               // Object.keys(data[db][np.v][np.table.pk]).forEach(fid => {
// //               Object.keys(Field).forEach(fid => {
// //                 // if (fid==REVIEWS)debugger
// // if (fid=='selectitem')debugger
// // if (fid=='selectreview')debugger
// //                 // if (id==fid) data[db][np.v][np.table.pk][fid].callback(value)
// // // if (id!='medias' && value.length && id==fid) debugger
// // // if (id==fid) Field[fid][''].callback(value)
// // // if (np.control && value.length) debugger
// // // if ((id=='items' || id=='reviews') && id==fid) debugger
// // // if (!(id=='items' || id=='reviews') && id==fid) Field[fid][''].callback(value)
// //                 // if (id==fid) Field[fid][''].callback(value)
// //                 if (callback) {
// // // if (fid=='items') debugger
// // // if (callback && pv=='item') debugger
// //                   // callback(value)
// //                 }
// //               })
// //             }
//           }
//           break
//           // case _.COUNT: break
//           // default: debugger
//         }
//         return ks
//       }, {}) // ks
//       return dbs
//     }, {}) // dbs
//     if (Object.keys(wakeup[v][ndb]||{}).length==0) {
//       delete(wakeup[v][ndb])
//     }
//     // last = Object.keys(wakeup[v]).length==0
// if (!v) debugger
//     last = Object.keys(wakeup[v]).length==0
//     if (last) {
//       delete(wakeup[v])
//       update=true
//     }
//     return vs
//   }, {}) // vs
//   if (update) {
//     console.log(`Row.memo ${np.ID} ${last?'last':'not last'}`, {ndb, nv, npk, wakeup, 'copy(pp.master.wakeup)': copy(pp.master.wakeup), 'copy(np.master.wakeup)': copy(np.master.wakeup)})
// // if (callback && pv=='item') debugger
//     const nwakeup = {
//       meta: {
//         db: ndb,
//         v: nv,
//         pk: npk,
//       },
//       wakeup
//     }
//     // if (callback) {
//     //   // callback()
//     //   nwakeup.meta.callback = callback
//     // }
//     np.setWakeup(nwakeup)
//   }
//   return false
//   // }
//   // console.log(`Row.memo ${np.ID}`, {db, v, pk, wakeup: Object.keys(wakeup||{}).length, 'sleep': pdata})
//   // return pdata
// })
